module.exports = __webpack_public_path__ + "img/services-icon-5.d6e015cb.png";